<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'" v-bg="{image: test.background, alternative: true, dir: 'to left'}">

    <app-loader v-if="loading"></app-loader>
    <div v-else :id="'test-' + id" class="test text-black-shadow">
      <div class="back-browser fadein-browser"
      @click="directFinish" v-if="$store.getters.platform === 'browser'">
        <icon name="arrow-left"></icon>
      </div>
      <div style="text-align:center;">
        <p style="float:left;text-align:left;">{{test.intro | truncateText(120)}}</p><br>
        <span style="float:left;text-align:left;">{{test.name | truncateText(120)}}</span><br>
        <img :src="test.image">
      </div>
      <div>
        <ul>
          <li v-for="item in test.test_answer" :key='item.id' v-on:click="evaluate(item)" v-on:keyup.enter="evaluate(item)" class="focusable">{{item.response | truncateText(75)}}</li>
        </ul>
        <span>{{feedback}}</span>
        <!-- <div v-if="feedback" class="finish" @click="directFinish">Continuar <icon name="arrow-right"></icon></div> -->
      </div>
    </div>

  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Bus from '@/components/ControlBus'
import SpatialNavigation from 'js-spatial-navigation'
import {StatsTest} from '@/utils/constants'
const contentsService = require('@/services/contents.js')

export default {
  name: 'Test',
  props: ['id'],
  components: { 'app-loader': Loader },
  data () {
    return {
      test: {},
      feedback: '',
      evaluated: false
    }
  },
  created: function () {
    contentsService.getTest(this.id).then(response => {
      this.test = response.data
      window.Countly.q.push(['track_pageview', StatsTest + ' ' + this.test.id + ': ' + this.test.name])
      setTimeout(() => this.initControls(), 0)
    })

    if (this.$store.getters.platform === 'browser') {
      const backRoot = document.getElementById('back-browser-root')
      if (backRoot) backRoot.style.display = 'none'
    }
  },
  mounted: function () {
    // control keys
    Bus.$on('key-enter', this.finish)
    Bus.$on('key-back', this.finish)
  },
  computed: {
    loading: function () { return Object.keys(this.test).length === 0 }
  },
  methods: {
    initControls () {
      this.SN = SpatialNavigation.add({selector: '#test-' + this.id + ' .focusable', restrict: 'self-only'})
      SpatialNavigation.makeFocusable()
      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()
    },
    evaluate: function (item) {
      if (!this.evaluated) {
        // feedback
        if (item.order === this.test.correct) {
          // correcto
          this.test.success_feedback ? this.feedback = this.test.success_feedback : this.feedback = this.$i18n.t('CONTENT.TEST-SUCCESS')
        } else {
          // incorrecto
          this.test.fail_feedback ? this.feedback = this.test.fail_feedback : this.feedback = this.$i18n.t('CONTENT.TEST-FAIL')
        }
        // save server
        contentsService.setAnswer(this.test.id, item.id)
          .then(response => {
            this.evaluated = true
          })
          .catch((error) => {
            console.error(error.response)
            this.evaluated = true
          })
      }
    },
    finish: function () {
      if (this.evaluated) { this.$emit('onFinish') }
    },
    directFinish: function () {
      this.$emit('onFinish')
    }
  },
  beforeDestroy: function () {
    if (this.$store.getters.platform === 'browser') {
      const backRoot = document.getElementById('back-browser-root')
      if (backRoot) backRoot.style.display = 'block'
    }
    Bus.$off('key-enter', this.finish)
    Bus.$off('key-back', this.finish)
    if (this.SN) { SpatialNavigation.remove(this.SN) }
    SpatialNavigation.pause()
  }
}
</script>

<style lang="sass" scoped>
.test
  position: relative
  width: 100vw
  height: 100vh
  padding: 3rem
  color: white

  display: flex
  display: -webkit-flex
  flex-direction: row
  justify-content: flex-end
  align-items: center

  div
    width: 50%
    padding: 3rem
    line-height: 1.1

    p
      font-size: 1.6rem

    span
      font-size: 1.6rem
      font-weight: bold

    img
      padding-top: 1rem
      max-width: 70%

    li
      font-size: 1.6rem
      cursor: pointer
      padding-bottom: 15px

    .finish
      cursor: pointer
      width: 100%
      text-align: right
      font-size: 2rem
      font-weight: bold

.focusable:focus
  color: #fff
  // background-color: #868686
  border-color: transparent
  outline: none;
  text-decoration: underline;

@media screen and (max-width: 700px)
  .test
    div
      p, span, li
        font-size: 1rem

</style>



// WEBPACK FOOTER //
// src/components/Test.vue